import React from 'react';  
import styled from 'styled-components';  

const DataCardsContainerWrapper = styled.div`  
    display: flex;  
    justify-content: space-around;  
    margin-bottom: 20px;  
    width: 100%;  
`;  

const DataCardOverlay = styled.div`  
    background-color: #ffffff; /* カードの背景を白に変更 */
    border-radius: 15px;  /* 角を丸く */
    padding: 10px;  
    text-align: center;  
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 影を追加して浮かび上がる効果 */
    flex: 1;  
    display: flex;  
    flex-direction: column;  
    justify-content: center;  
    align-items: center;  
`;  

const DataValueOverlay = styled.div`  
    font-size: 2.5vw;  
    color: ${({ color }) => color || 'black'};  
    font-weight: bold;  
    margin-bottom: 5px; /* 数値の下に余白を追加 */
    @media (max-width: 768px) {  
        font-size: 4.5vw;  
    }  
`;  

const DataLabelOverlay = styled.div`  
    font-size: 1.2rem; /* フォントサイズを少し小さく */
    color: #666666; /* ラベルの色を少し落ち着いた色に変更 */
    margin-top: 5px;  
    @media (max-width: 768px) {  
        font-size: 4vw;  
    }  
`;  

const DataCardsContainer = ({ farmData }) => {  
    const optimalTemperatureRange = [20, 25];  
    const optimalHumidityRange = [50, 70];  
    const optimalCO2Range = [600, 1000];  

    const temperatureData = farmData.data?.InAirTempAve || [];  
    const humidityData = farmData.data?.InAirHumid || [];  
    const co2Data = farmData.data?.InAirCO2 || [];  
    const radiationData = farmData.data?.WRadInteg || [];  

    const currentTemperature = temperatureData[temperatureData.length - 1] || null;  
    const currentHumidity = humidityData[humidityData.length - 1] || null;  
    const currentCO2 = co2Data[co2Data.length - 1] || null;  
    const currentRadiation = radiationData[radiationData.length - 1] || null;  

    const isTemperatureOptimal = currentTemperature >= optimalTemperatureRange[0] && currentTemperature <= optimalTemperatureRange[1];  
    const isHumidityOptimal = currentHumidity >= optimalHumidityRange[0] && currentHumidity <= optimalHumidityRange[1];  
    const isCO2Optimal = currentCO2 >= optimalCO2Range[0] && currentCO2 <= optimalCO2Range[1];  

    return (  
        <DataCardsContainerWrapper>  
            <DataCardOverlay>  
                <DataValueOverlay color="green" $isOptimal={isTemperatureOptimal}>  
                    {currentTemperature !== null ? `${currentTemperature.toFixed(1)}°C` : 'NULL'}  
                </DataValueOverlay>  
                <DataLabelOverlay>温度</DataLabelOverlay>  
            </DataCardOverlay>  
            <DataCardOverlay>  
                <DataValueOverlay color="green" $isOptimal={isHumidityOptimal}>  
                    {currentHumidity !== null ? `${currentHumidity.toFixed(1)}%` : 'NULL'}  
                </DataValueOverlay>  
                <DataLabelOverlay>湿度</DataLabelOverlay>  
            </DataCardOverlay>  
            <DataCardOverlay>  
                <DataValueOverlay color="green" $isOptimal={isCO2Optimal}>  
                    {currentCO2 !== null ? `${currentCO2.toFixed(1)}ppm` : 'NULL'}  
                </DataValueOverlay>  
                <DataLabelOverlay>CO2濃度</DataLabelOverlay>  
            </DataCardOverlay>  
            <DataCardOverlay>  
                <DataValueOverlay color="green">  
                    {currentRadiation !== null ? `${currentRadiation.toFixed(1)} MJ/m²` : 'NULL'}  
                </DataValueOverlay>  
                <DataLabelOverlay>積算日射</DataLabelOverlay>  
            </DataCardOverlay>  
        </DataCardsContainerWrapper>  
    );  
};  

export default DataCardsContainer;
